<template>
    <div class="eureka-air flex h-screen w-screen flex-col overflow-y-hidden lg:flex-row">
        <NavBar :headerService="headerService" :navModuleType="NAV_MENU_TYPE.TECH_RESEARCH" />
        <div class="h-full flex-1">
            <router-view></router-view>
        </div>
    </div>
</template>
<script setup lang="ts">
import { onBeforeMount } from 'vue';
import { NavBar, NAV_MENU_TYPE } from '@eureka/nav-bar';
import { controlDeferred } from '@eureka/utils/control';
import { useHeaderService } from './composables/use-header-service';
import { UsageAmountWhere } from '@eureka/edition-upgrade/src/constants';
import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';

const { headerService } = useHeaderService();

onBeforeMount(async() => {
    const { is_first_login_after_try_end } = await controlDeferred.promise;
    if (is_first_login_after_try_end) {
        import('@eureka/edition-upgrade').then((mod) => {
            mod.prepareFirstLoginAfterTrial(UsageAmountWhere.TECH_RESEARCH, EurekaPackageType.AIR_COMMERCIAL);
        });
    }
})
</script>

<style lang="scss">
.eureka-air {

    .project-create-step,
    .project-create-chat {
        height: 100% !important;
    }
}
</style>
